export default __webpack_public_path__ + "static/media/semitransparent_middle_frame.acde909f.svg";